export { default } from './Footer';